export const PATHS = {
  root: "https://jezfx.com"
};
